import processSelector from "./process"

export default function selectPending(state, model, id) {
  const process = processSelector(state, model, id)

  return Boolean(process)
}
